import QRCodeSVG from '../../../elements/QRCode';
import React from 'react';
import { Align } from '../../../modules/ReceiptLayouts/Model';
export var BlockQR = function (_a) {
    var ticket = _a.ticket, align = _a.align;
    return (React.createElement("div", { style: { width: '100%', display: 'grid', justifyContent: align || defaultProps.align } },
        React.createElement("span", null, "".concat(ticket.numero)),
        React.createElement("div", { style: { width: '100%', display: 'grid', justifyContent: align || defaultProps.align } },
            React.createElement(QRCodeSVG, { value: ticket.numero, size: 100, level: 'H' }))));
};
var defaultProps = {
    align: Align.Center
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockQR.tsx
// module id = 493
// module chunks = 0